export const Data = [
  {
    type: "zh",
    itemTitle:"临床应用",
    itemMore:"查看更多",
    llyyItem:[
      {
        index:1,
        text1:"美学修复",
        text2:"牙周清创，辅助龈下刮治和根面平整，牙龈切除或修整，牙龈瘤切除，牙周翻瓣手术，闭合式冠延长术",
        showData:false,
        imgUrl:"https://www.victrum.com/image/tp/美学修复-入口图.png"},
      {
        index:2,
        text1:"外科种植",
        text2:"窝沟封闭，牙髓凝固，活髓切断，切开助萌",
        showData:false,
        imgUrl:"https://www.victrum.com/image/tp/外科种植-入口图.png",
      },{
        index:3,
        text1:"牙体牙髓",
        text2:"窝沟封闭，牙髓凝固，活髓切断，切开助萌",
        showData:false,
        imgUrl:"https://www.victrum.com/image/tp/牙体牙髓-入口图.png",
      },{
        index:4,
        text1:"牙周疾病",
        text2:"窝沟封闭，牙髓凝固，活髓切断，切开助萌",
        showData:false,
        imgUrl:"https://www.victrum.com/image/tp/牙周疾病-入口图.png",
      },{
        index:5,
        text1:"正畸儿牙",
        text2:"窝沟封闭，牙髓凝固，活髓切断，切开助萌",
        showData:false,
        imgUrl:"https://www.victrum.com/image/tp/正畸儿牙-入口图.png",
      }
      //    ,
      // {
      //   index:3,
      //   showData:true,
      //   imgUrl:"https://fuss10.elemecdn.com/1/34/19aa98b1fcb2781c4fba33d850549jpeg.jpeg",
      //      },
      // {
      //   index:4,
      //   showData:false,
      //   imgUrl:"https://fuss10.elemecdn.com/0/6f/e35ff375812e6b0020b6b4e8f9583jpeg.jpeg",
      //    },
      // {
      //   index:5,
      //   showData:false,
      //   imgUrl:"https://fuss10.elemecdn.com/9/bb/e27858e973f5d7d3904835f46abbdjpeg.jpeg",
      //          }
    ]
  },
  {
    type: "en",
    itemTitle:"Clinical Applications",
    itemMore:"View More",
    llyyItem:[
      {
        index:1,
        text1:"美学修复",
        text2:"瓷贴面拆除、牙龈脱色、笑线设计、前庭沟加深成形、牙龈磨削、排龈术",
        showData:false,
        imgUrl:"https://www.victrum.com/image/tp/美学修复-入口图.png"},
      {
        index:2,
        text1:"外科种植",
        text2:"种植二期手术、种植体周围炎维护及治疗、复杂牙拔除、牙槽骨修整、软组织囊肿摘除",
        showData:false,
        imgUrl:"https://www.victrum.com/image/tp/外科种植-入口图.png",
      },{
        index:3,
        text1:"牙体牙髓",
        text2:"去腐备洞、盖髓、牙本质脱敏、根管荡洗消毒、根尖切除术、激光蚀刻等",
        showData:false,
        imgUrl:"https://www.victrum.com/image/tp/牙体牙髓-入口图.png",
      },{
        index:4,
        text1:"牙周疾病",
        text2:"牙周袋内清创、龈下刮治及平整、牙龈切除修整、牙龈瘤切除、牙周翻瓣术等",
        showData:false,
        imgUrl:"https://www.victrum.com/image/tp/牙周疾病-入口图.png",
      },{
        index:5,
        text1:"正畸儿牙",
        text2:"牙釉质蚀刻、陶瓷托槽脱粘接、埋伏牙开窗牵引、窝沟封闭、活髓切断、切开助萌、唇舌系带修整等",
        showData:false,
        imgUrl:"https://www.victrum.com/image/tp/正畸儿牙-入口图.png",
      }

    ]
  }
]



// WEBPACK FOOTER //
// ./src/components/js/image/llyy.js